export enum General {
    View = "Reporting.General.View",
    Download = "Reporting.General.Download",
}